import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";

/** Placeholder that mirrors the Summary Strip cards while the interface coverage totals are loading. */
const SummaryStripSkeleton = () => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            border: "1px solid #0000001F",
            borderRadius: "8px",
            padding: "8px",
            height: "66px",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Skeleton width="60%" height={22} />
              <Skeleton width="85%" height={18} />
            </Box>
            <Skeleton width={50} height={30} />
          </Box>
        </Box>
      ))}
    </>
  );
};

export default SummaryStripSkeleton;
